import type { ReactNode } from "react";

/** Header tipográfico pequeño que separa secciones del sidebar ("Navegación", "Administración"). */
export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <p className="mb-1.5 px-2 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
      {children}
    </p>
  );
}
